/**
 * Ar App
 * This is a simple API for AR App
 *
 * OpenAPI spec version: 1.0.0
 * Contact: csong@lsq.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ArError } from '../model/arError';
import { FieldSchema } from '../model/fieldSchema';
import { ProspectData } from '../model/prospectData';
import { ProspectSchema } from '../model/prospectSchema';
import { V1DocumentRequestBody } from '../model/v1DocumentRequestBody';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class DocumentService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Request a new document or documents
     * Adds document fields to a pre-existing prospectSchema
     * @param body An array of documents to request
     * @param prospectId Id of the prospectData associated with the schema to be changed
     * @param stageId Id of the stage where documents should be added
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addDocumentRequest(body: V1DocumentRequestBody, prospectId: string, stageId: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectSchema>;
    public addDocumentRequest(body: V1DocumentRequestBody, prospectId: string, stageId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectSchema>>;
    public addDocumentRequest(body: V1DocumentRequestBody, prospectId: string, stageId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectSchema>>;
    public addDocumentRequest(body: V1DocumentRequestBody, prospectId: string, stageId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addDocumentRequest.');
        }

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling addDocumentRequest.');
        }

        if (stageId === null || stageId === undefined) {
            throw new Error('Required parameter stageId was null or undefined when calling addDocumentRequest.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospectId', <any>prospectId);
        }
        if (stageId !== undefined && stageId !== null) {
            queryParameters = queryParameters.set('stageId', <any>stageId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProspectSchema>('post',`${this.basePath}/v1/documentRequest`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deletes document
     * 
     * @param documentId pass the DocumentId for looking up document. (Document key in S3 bucket)
     * @param prospectId Prospect Id
     * @param stageSchemaId pass the StageSchemaID to update
     * @param fieldSchemaId FieldSchema Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDocument(documentId: string, prospectId: string, stageSchemaId: string, fieldSchemaId: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public deleteDocument(documentId: string, prospectId: string, stageSchemaId: string, fieldSchemaId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public deleteDocument(documentId: string, prospectId: string, stageSchemaId: string, fieldSchemaId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public deleteDocument(documentId: string, prospectId: string, stageSchemaId: string, fieldSchemaId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling deleteDocument.');
        }

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling deleteDocument.');
        }

        if (stageSchemaId === null || stageSchemaId === undefined) {
            throw new Error('Required parameter stageSchemaId was null or undefined when calling deleteDocument.');
        }

        if (fieldSchemaId === null || fieldSchemaId === undefined) {
            throw new Error('Required parameter fieldSchemaId was null or undefined when calling deleteDocument.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (documentId !== undefined && documentId !== null) {
            queryParameters = queryParameters.set('document_id', <any>documentId);
        }
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }
        if (stageSchemaId !== undefined && stageSchemaId !== null) {
            queryParameters = queryParameters.set('stage_schema_id', <any>stageSchemaId);
        }
        if (fieldSchemaId !== undefined && fieldSchemaId !== null) {
            queryParameters = queryParameters.set('field_schema_id', <any>fieldSchemaId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProspectData>('delete',`${this.basePath}/v1/document`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a document request
     * Deletes document fields from a pre-existing prospectSchema
     * @param prospectId Id of the prospectData associated with the schema to be changed
     * @param stageId Id of the stage where the document should be deleted
     * @param fieldId Id of the document field that should be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDocumentRequest(prospectId: string, stageId: string, fieldId: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectSchema>;
    public deleteDocumentRequest(prospectId: string, stageId: string, fieldId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectSchema>>;
    public deleteDocumentRequest(prospectId: string, stageId: string, fieldId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectSchema>>;
    public deleteDocumentRequest(prospectId: string, stageId: string, fieldId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling deleteDocumentRequest.');
        }

        if (stageId === null || stageId === undefined) {
            throw new Error('Required parameter stageId was null or undefined when calling deleteDocumentRequest.');
        }

        if (fieldId === null || fieldId === undefined) {
            throw new Error('Required parameter fieldId was null or undefined when calling deleteDocumentRequest.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospectId', <any>prospectId);
        }
        if (stageId !== undefined && stageId !== null) {
            queryParameters = queryParameters.set('stageId', <any>stageId);
        }
        if (fieldId !== undefined && fieldId !== null) {
            queryParameters = queryParameters.set('fieldId', <any>fieldId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProspectSchema>('delete',`${this.basePath}/v1/documentRequest`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Downloads a prospect document.
     * Downloads a prospect document from the file store.
     * @param documentId id of the document to download (key in the S3 bucket)
     * @param prospectId Prospect Id
     * @param includeDeleted Whether to download a deleted document. default to false. Only used by Admins.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadDocument(documentId: string, prospectId: string, includeDeleted?: boolean, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public downloadDocument(documentId: string, prospectId: string, includeDeleted?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public downloadDocument(documentId: string, prospectId: string, includeDeleted?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public downloadDocument(documentId: string, prospectId: string, includeDeleted?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling downloadDocument.');
        }

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling downloadDocument.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (documentId !== undefined && documentId !== null) {
            queryParameters = queryParameters.set('document_id', <any>documentId);
        }
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }
        if (includeDeleted !== undefined && includeDeleted !== null) {
            queryParameters = queryParameters.set('include_deleted', <any>includeDeleted);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('get',`${this.basePath}/v1/document`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update one or several document requests
     * Updates document fields to a pre-existing prospectSchema
     * @param body The document object to update
     * @param prospectId Id of the prospectData associated with the schema to be changed
     * @param stageId Id of the stage where documents should be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDocumentRequest(body: FieldSchema, prospectId: string, stageId: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectSchema>;
    public updateDocumentRequest(body: FieldSchema, prospectId: string, stageId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectSchema>>;
    public updateDocumentRequest(body: FieldSchema, prospectId: string, stageId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectSchema>>;
    public updateDocumentRequest(body: FieldSchema, prospectId: string, stageId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateDocumentRequest.');
        }

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling updateDocumentRequest.');
        }

        if (stageId === null || stageId === undefined) {
            throw new Error('Required parameter stageId was null or undefined when calling updateDocumentRequest.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospectId', <any>prospectId);
        }
        if (stageId !== undefined && stageId !== null) {
            queryParameters = queryParameters.set('stageId', <any>stageId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProspectSchema>('put',`${this.basePath}/v1/documentRequest`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Upload a prospect document.
     * Uploads a prospect document to the file store.
     * @param documentFile 
     * @param documentNotes 
     * @param prospectId 
     * @param stageSchemaId 
     * @param fieldSchemaId 
     * @param fileName 
     * @param asOfDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadDocumentForm(documentFile: Blob, documentNotes: string, prospectId: string, stageSchemaId: string, fieldSchemaId: string, fileName: string, asOfDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public uploadDocumentForm(documentFile: Blob, documentNotes: string, prospectId: string, stageSchemaId: string, fieldSchemaId: string, fileName: string, asOfDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public uploadDocumentForm(documentFile: Blob, documentNotes: string, prospectId: string, stageSchemaId: string, fieldSchemaId: string, fileName: string, asOfDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public uploadDocumentForm(documentFile: Blob, documentNotes: string, prospectId: string, stageSchemaId: string, fieldSchemaId: string, fileName: string, asOfDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (documentFile === null || documentFile === undefined) {
            throw new Error('Required parameter documentFile was null or undefined when calling uploadDocument.');
        }

        if (documentNotes === null || documentNotes === undefined) {
            throw new Error('Required parameter documentNotes was null or undefined when calling uploadDocument.');
        }

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling uploadDocument.');
        }

        if (stageSchemaId === null || stageSchemaId === undefined) {
            throw new Error('Required parameter stageSchemaId was null or undefined when calling uploadDocument.');
        }

        if (fieldSchemaId === null || fieldSchemaId === undefined) {
            throw new Error('Required parameter fieldSchemaId was null or undefined when calling uploadDocument.');
        }

        if (fileName === null || fileName === undefined) {
            throw new Error('Required parameter fileName was null or undefined when calling uploadDocument.');
        }

        if (asOfDate === null || asOfDate === undefined) {
            throw new Error('Required parameter asOfDate was null or undefined when calling uploadDocument.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling uploadDocument.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (documentFile !== undefined) {
            formParams = formParams.append('document_file', <any>documentFile) as any || formParams;
        }
        if (documentNotes !== undefined) {
            formParams = formParams.append('document_notes', <any>documentNotes) as any || formParams;
        }
        if (prospectId !== undefined) {
            formParams = formParams.append('prospect_id', <any>prospectId) as any || formParams;
        }
        if (stageSchemaId !== undefined) {
            formParams = formParams.append('stage_schema_id', <any>stageSchemaId) as any || formParams;
        }
        if (fieldSchemaId !== undefined) {
            formParams = formParams.append('field_schema_id', <any>fieldSchemaId) as any || formParams;
        }
        if (fileName !== undefined) {
            formParams = formParams.append('file_name', <any>fileName) as any || formParams;
        }
        if (asOfDate !== undefined) {
            formParams = formParams.append('as_of_date', <any>asOfDate) as any || formParams;
        }
        if (endDate !== undefined) {
            formParams = formParams.append('end_date', <any>endDate) as any || formParams;
        }

        return this.httpClient.request<ProspectData>('post',`${this.basePath}/v1/document`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
